import { useTranslate } from 'hooks/use-translation';

export const tooltipForAutoAllocate = (
  translate: ReturnType<typeof useTranslate>,
): string =>
  `<div>${translate('templates.resource_management.autofill.tooltip', {
    b: (chunks) => `<strong>${chunks}</strong>`,
    br: () => '<br />',
  })}</div>`;
